import React from "react";
import ReactEcharts from "echarts-for-react";

const PieChart = ({ projectWorkers, centerTitle, centerValue }) => {
  const totalWorkers = projectWorkers?.reduce((sum, project) => 
    sum + parseInt(project.total_employees || 0), 0);

  // Define colors for specific items - Exact from manager portal
  const colorMap = {
    'Active Projects': 'rgba(92, 123, 199, 1)', // Medium Blue
    'Deactivated Projects': 'rgba(139, 195, 143, 1)', // Soft Green
    'Active Organizations': 'rgba(92, 123, 199, 1)', // Medium Blue
    'Inactive Organizations': 'rgba(139, 195, 143, 1)', // Soft Green
  };

  const pieData = projectWorkers?.map(project => ({
    value: parseInt(project.total_employees || 0),
    name: project.title,
    itemStyle: {
      color: colorMap[project.title] || undefined
    }
  })).filter(item => item.value > 0);

  const displayTitle = centerTitle || 'Total Workers';
  const displayValue = centerValue !== undefined ? centerValue : totalWorkers;

  const option = {
    tooltip: {
      trigger: "item",
      formatter: '{b}: {c} ({d}%)'
    },
    legend: {
      bottom: "5%",
      left: "center",
      type: 'scroll',
      orient: 'horizontal',
      pageButtonPosition: 'end',
      pageIcons: {
        horizontal: [
          'path://M10 0 L0 8 L10 16', // Left arrow
          'path://M0 0 L10 8 L0 16'   // Right arrow
        ]
      },
      pageIconColor: '#F97316', // Orange color to match your theme
      pageIconInactiveColor: '#ddd',
      pageIconSize: 8, // Smaller, more subtle arrows
      textStyle: {
        fontSize: 11,
        width: 80
      },
      formatter: function(name) {
        return name.length > 12 ? name.slice(0, 12) + '...' : name;
      },
      pageTextStyle: {
        color: '#888'
      },
      itemGap: 15,
      itemWidth: 10,
      itemHeight: 10,
      padding: [5, 10],
    },
    title: {
      text: `${displayTitle}\n${displayValue || 0}`,
      left: "center",
      top: "center",
      textStyle: {
        fontSize: 20,
        fontWeight: "bold",
        lineHeight: 30,
      },
    },
    series: [
      {
        name: "Project Workers",
        type: "pie",
        radius: ["40%", "65%"],
        center: ['50%', '45%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
        },
        emphasis: {
          label: {
            show: false,
          },
        },
        labelLine: {
          show: false,
        },
        data: pieData,
      },
    ],
  };

  return (
    <div className="w-full h-full">
      <ReactEcharts
        option={option}
        style={{ height: "100%", width: "100%", marginTop: "-1.5rem" }}
      />
    </div>
  );
};

export default PieChart;
